import {Team, TeamContract} from 'app/components/entities/team/models';
import {Admin} from 'app/models/PermissionsModel/Admin';
import {Operator} from 'app/models/PermissionsModel/Operator';
import {Owner} from 'app/models/PermissionsModel/Owner';

function mapMember(c: TeamContract.Member): Team.Member {
  return {
    id: c.ID,
    name: c.Name,
    email: c.Email,
    loginType: c.LoginType,
    pending: c.Status === 'pending',
    picture: c.Picture,
    role: mapRoleType(c.UserRole, c.IsMaster),
  };
}

function mapTeam(c: TeamContract.Team): Team.Team {
  return {id: c.TeamID, name: c.TeamName, role: mapRoleType(c.UserRole, c.IsMaster)};
}

function mapTeamDetails(c: TeamContract.TeamDetails): Team.TeamDetails {
  return {
    id: c.ID,
    name: c.Name,
    email: c.BillingEmail,
    caps: mapCapabilities(c.Caps),
    delinquent: c.Delinquent,
  };
}

function mapCapabilities(c: TeamContract.Capabilities): Team.Capabilities {
  return {
    cms: c.team_can_use_cms,
    batch: c.team_can_use_batch,
    transcribing: c.team_can_use_transcribing,
    presets: c.team_can_use_preset,
    groups: c.team_can_use_groups,
    connect: c.team_can_use_epiphanconnect,
    unify: c.team_can_use_unify,
    resumeUnify: c.team_can_resume_unify,
    startConnect: c.team_can_start_epiphanconnect,
    files: c.team_can_use_filemanagement,
  };
}

function mapRoleType(role: TeamContract.RoleType, master: boolean): Team.RoleType {
  if (role === 'owner') {
    if (master) {
      return 'owner';
    }

    return 'admin';
  }

  return 'operator';
}

function getRoleClass(role: Team.RoleType) {
  if (role === 'owner') {
    return new Owner();
  }

  if (role === 'admin') {
    return new Admin();
  }

  return new Operator();
}

export const TeamMapper = {
  mapMember,
  mapTeamDetails,
  mapTeam,
  mapRoleType,
  getRoleClass,
};
